import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { CachingService } from '../../services/caching.service';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HomeComponent implements OnInit {
  private router = inject(Router);
  private cachingService = inject(CachingService);
  private userService = inject(UserService);

  user = toSignal(this.userService.getUserInfo$());

  ngOnInit(): void {
    this.cachingService.clearChainEditCache();
  }

  openProfile(): void {
    this.router.navigate(['/profile']);
  }
}
